const STORAGE_KEY = 'nangbook-selected-property-id';

let selectedPropertyId: number | null = readSelectedPropertyId();

export function getSelectedPropertyId(): number | null {
  return selectedPropertyId;
}

export function setSelectedPropertyId(propertyId: number | null): void {
  selectedPropertyId = propertyId;

  if (typeof window === 'undefined') return;

  if (propertyId === null) {
    window.localStorage.removeItem(STORAGE_KEY);
  } else {
    window.localStorage.setItem(STORAGE_KEY, String(propertyId));
  }
}

function readSelectedPropertyId(): number | null {
  if (typeof window === 'undefined') return null;

  const stored = window.localStorage.getItem(STORAGE_KEY);
  const parsed = stored ? Number(stored) : NaN;

  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}
